var _ = require('lodash')
    , Dexie              = require('Dexie').default
    , Promise            = Dexie.Promise
    , helpers            = require('Helpers')
    , models             = { GalleryKey      : require('GalleryKey'), 
                             ApplicationState: require('ApplicationState'), 
                             UserSession     : require('UserSession'), 
                             PreviousState   : require('GalleryKey'),
                             History         : require('GalleryDetails')
                           }
    , emitter            = require('events')
    , md5                = require("md5")
    , applicationEvents  = require('ApplicationEvents')
    , controllerEvents   = require('ControllerEvents')


    , applicationStateDb = new Dexie('applicationState0.0.1')
    , tableDefinitions   = _.mapKeys(models, helpers.formatTableName)
    , tableClassStrings  = _.mapValues(tableDefinitions, helpers.definitionToString)
    , stringified        = JSON.stringify(_(tableClassStrings).toPairs().sortBy(_.head).fromPairs().value() )
    , md5ified           = md5(stringified);

applicationStateDb.md5 = md5ified;
applicationStateDb.version(1).stores(tableClassStrings);


_.forIn(tableDefinitions, function (definition, tableName) { applicationStateDb[tableName].mapToClass(definition) });



var ApplicationStateController = function (_, core, params, helpers, events, interControllerEmitter, console, appController, searchServerController) {


    var self         = this, sessionId
      , eventEmitter = interControllerEmitter
      , moment       = core.Moment
      , Guid         = core.Guid;


    var assertGalleryKey = function (galleryKey) {
        if (!galleryKey) {
            throw 'need gallery Key';
        }
    }

        , createStateRecord = function (galleryKey, sessionId) {

            assertGalleryKey(callId);
            return helpers.createInstanceWithValues(models.GalleryKey, { GalleryKey: galleryKey, Name: null, IsCurrentGallery: 1, startupview: 'info' });
        }

        , assignToState = function (state, update) {

            return helpers.createInstanceWithValues(models.GalleryKey, _.assign(state, update));
        }

        , memos = {}

        , saveRecord = function (record) {


            assertGalleryKey(record && record.GalleryKey);


            console.error('saveRecord', record.GalleryKey);

            memos[record.GalleryKey] = record;

            return applicationStateDb.galleryKeys.put(record).then(function (numberOfModifiedObjects) {

                console.info('numberOfModifiedObjects', numberOfModifiedObjects);

            }).then(function () {

                console.info('saved', record);

                return record;

            });


        }

        , getRecord = function (galleryKey) {

            assertGalleryKey(galleryKey);

            console.error('get gallery key', galleryKey, 'memos', memos);

            return memos[galleryKey] ? Promise.resolve(memos[galleryKey]) : applicationStateDb.galleryKeys.where('GalleryKey').equals(galleryKey).first(function (record) {

                console.info('fetched application state record for ', galleryKey, record);
                memos[galleryKey] = record;
                return record;
            })

        }
        , getHistoric = function (galleryKey) {

            assertGalleryKey(galleryKey);

            console.error('get historic', galleryKey);

            return applicationStateDb.previousStates.where('GalleryKey').equals(galleryKey).first(function (record) {

                console.info('fetched gallery state record for ', galleryKey, record);
                return record;
            })

        }

        , displayStateRecord = function (obj) {

            gallerykey = obj && obj.GalleryKey || obj;

            assertGalleryKey(gallerykey);

            getRecord(gallerykey).then(function (record) { console.log('app state', record) });
        }

        , eventHandlers = {}

        , unMapEventsToFieldUpdatesByCallId = function () {

            _.each(eventHandlers, function (handler, event) { applicationEvents.emitter.removeListener(event, handler) });
            eventHandlers = {}
        }

        , mapEventsToFieldUpdatesByCallId = function (galleryKey, moment) {

            unMapEventsToFieldUpdatesByCallId()

            var timestamp = function () { return helpers.timeStamp(moment) }

            var map = [{ event: applicationEvents.form_selected, modify: function (form) { return form && form.FormId && { FormId: form.FormId } } }
                , { event: applicationEvents.enter_call, modify: function () { return { InCall: true } } }
                , { event: applicationEvents.leave_call, modify: function () { return { InCall: false } } }
                , { event: applicationEvents.questionnaire_onboard, modify: function () { return { QuestionnaireStoredOn: moment() } } }
                , { event: applicationEvents.answer_update, modify: function (data, record) { return _.assign(!record.FirstAnswerOn ? { FirstAnswerOn: timestamp() } : {}, { LastAnswerOn: timestamp() }) } }
                , { event: applicationEvents.call_upload_complete, modify: function () { return { CallUploaded: true, CallUploadedOn: timestamp() } }, completionEvent: controllerEvents.call_upload_recorded }
            ];

            eventHandlers = _.reduce(map, function (acculmalator, x) {
                console.error('setting events', acculmalator, x); return _.set(acculmalator, x.event, function (data) {

                    getRecord(galleryKey).then(function (record) {

                        var modified = assignToState(record, x.modify(data, record));

                        console.info('event', x.event, data, record, modified);

                        saveRecord(modified)
                            .then(function (saveOutcome) {
                                if (x.completionEvent) {

                                    console.error('emitting ')
                                    eventEmitter.emit(x.completionEvent)
                                }
                                return saveOutcome;
                            })
                            .then(displayStateRecord);

                    })


                })
            }, {});

            _.each(eventHandlers, function (handler, event) { applicationEvents.emitter.on(event, handler) });


        }

    _.assign(self, {
        getApplicationState: getRecord
        , save: saveRecord
        , assignToState: assignToState
        , applicationStateType: models.ApplicationState
        , getAll: function () { return applicationStateDb.galleryKeys.toArray() }
        , getHistoric: getHistoric
        , __applicationStateDb : applicationStateDb
        
    });


    ///////////////////////////////////////////////////
    var busyMessage = function (message) { console.info('BUSY MESSAGE', message); setTimeout(function () { events.emitter.emit(events.busy_message, message) }, 1) }
    ///////////////////////////////////////////////////

    var rightAtTheBeginning        = function (record) { busyMessage('Right at the beginning'); return { rightatthebeginning: true, state: record } }
    , yetToCompleteInitialization  = function (record) { busyMessage('Yet to complete Initialization', record); interControllerEmitter.emit(controllerEvents.needs_initializing, record); return record }
    , goToWhereEverWeLeftOff       = function (record) { return assignToState(record, { startupview: record.LastView || 'Info' }) }
    , ensureStartupStateFromRecord = function (record) {

            // may have these 

            return record.Initialized ? goToWhereEverWeLeftOff(record) : yetToCompleteInitialization(record);

        }



    self.saveGalleryKey = function (galleryKey, name, makeCurrent) {
        var galleryKeyUpdates = [];
        var isGalleryKeyAlreadySaved = false;
        console.warn("AppState save gallerykey...")
        return applicationStateDb.galleryKeys.toArray()
            .then(function (allGalleryKeys) {
                _.each(allGalleryKeys, function (nthGalleryKey) {
                    if (nthGalleryKey.GalleryKey === galleryKey) {
                        isGalleryKeyAlreadySaved = true;
                        if (name) {
                            nthGalleryKey.Name = name;
                        };
                        if (makeCurrent) {
                            nthGalleryKey.IsCurrentGallery = 1;
                            nthGalleryKey.LastLoadedOn     = moment().toDate();
                        }
                    } else {
                        if (makeCurrent) {
                            nthGalleryKey.IsCurrentGallery = 0;
                        }
                    }
                    galleryKeyUpdates.push(nthGalleryKey);
                })
                if (!isGalleryKeyAlreadySaved) {
                    var newGalleryKey = helpers.createInstanceWithValues(models.GalleryKey,
                        {
                            GalleryKey       : galleryKey,
                            Name             : name,
                            IsCurrentGallery : makeCurrent ? 1 : 0,
                            ClientToken      : Guid.create().toString().toUpperCase(),
                            LastLoadedOn     : makeCurrent ? moment().toDate() : undefined
                        });
                    galleryKeyUpdates.push(newGalleryKey);
                }
                 console.warn("AppState about to do updates....",galleryKeyUpdates)
                return applicationStateDb.galleryKeys.bulkPut(galleryKeyUpdates)
                    .then(function () { return applicationStateDb.galleryKeys.where('GalleryKey').equals(galleryKey).first() })

            });
    }

    var makeCurrent = function (key) {

        return applicationStateDb.galleryKeys.toCollection().modify(function(x){ 
            
            x.IsCurrentGallery = x.GalleryKey === key ? 1 : 0;
            
            if(x.IsCurrentGallery) x.LastLoadedOn = moment().toDate();
        
        })

    }

    self.logOut = function(){

        return applicationStateDb.galleryKeys.toCollection().modify(function(x){ 
            
            x.IsCurrentGallery = 0;
        })
    }

    self.getCurrentGalleryKey = function (paramsGalleryKey) {
        console.error('getCurrentGalleryKey from table',  paramsGalleryKey && 'Key from params ' + paramsGalleryKey );        
        
        return (paramsGalleryKey ?
          applicationStateDb.galleryKeys.where('GalleryKey').equals(paramsGalleryKey)
        : applicationStateDb.galleryKeys.where('IsCurrentGallery').equals(1)
        ).first()
         .then(function (galleryKey) { return galleryKey || null })
    }


    var fetchGalleryKey = function (galleryKey) {

        console.warn('ROOT: request to save new gallery key', galleryKey);
        return searchServerController.getGalleryDetails(galleryKey)
        
                .then(function (galleryDetails) {
                    console.warn("ROOT: uffff", galleryDetails);
                    return galleryDetails ? self.saveGalleryKey(galleryKey, galleryDetails.Name, true) : false;                
                })
    }

    self.ensureStartupState = function (userInputGalleryKey) {

        var galleryKey = params.galleryKey || userInputGalleryKey;

        console.error('ensure startup state', galleryKey || 'no Gallery Key Specified');

        if (galleryKey) {
            
            return applicationStateDb.galleryKeys.where('GalleryKey').equals(galleryKey).first()
                .then(function (galleryInfo) {
                        return galleryInfo ? makeCurrent(galleryKey).then(function(){return galleryInfo}) 
                                           : fetchGalleryKey(galleryKey);
                })
                .then(function(info){ 
                    appController.setCurrentGallery(info);
                    return { startupview: info ? 'direct' : 'splash', info : info } 
                
            });
            }


        if (!galleryKey) {

            return self.getCurrentGalleryKey()
                .then(function (galleryKeyInfo) {
                    if (galleryKeyInfo) {
                        return { GalleryKey: galleryKeyInfo.GalleryKey, startupview: 'splash' }
                    }
                    console.info('no gallery key supplied - going to request user input');

                    return Promise.resolve({ startupview: 'gallerykeyinputneeded' });
                })
        }

        return applicationStateDb.previousStates.where('GalleryKey').equals(galleryKey).first(function (history) {

            console.error('State history record for ', galleryKey, history);

            if (history) return { startupview: 'history', callId: callId, state: history }

            mapEventsToFieldUpdatesByCallId(callId, core.Moment);

            userInputGalleryKey && events.emitter.removeListener(events.selected_call_id, self.ensureStartupState);

            return getRecord(callId).then(function (_record) {

                console.info('callid ', callId, _record || 'No record for this callid - creating fresh record to store if verifies');

                return ensureStartupStateFromRecord(_record || createStateRecord(callId, sessionId))

            });
        })




    }

    events.emitter.on(events.selected_call_id, self.ensureStartupState);
    
    events.emitter.on(events.remove_history_item, function(galleryKey){

        applicationStateDb.galleryKeys.where('GalleryKey').equals(galleryKey).delete();

        ko.storage.clear('filters', 'guest');
    });

    

    // test: self.await = applicationStateDb.applicationStates.clear().then(pushFirstStateRecord).then(getRecord);
    self.bootstrap = self.ensureStartupState();  // getRecord().then(function(record){ record ? displayStateRecord() : pushFirstStateRecord() } ).then(getRecord);

}

ApplicationStateController.__applicationStateDb = applicationStateDb;
module.exports = ApplicationStateController;
